import { render } from "./AddRoleModal.vue?vue&type=template&id=0506ba1a&ts=true"
import script from "./AddRoleModal.vue?vue&type=script&lang=ts"
export * from "./AddRoleModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__